import { Injectable } from "@angular/core";
import { CrudService } from "app/shared/crud-service";
import { HttpClient } from "@angular/common/http";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { RegrasLimiteDespesaViagemDTO } from "../models/regras-limite-despesa-viagem.model";
import { environment } from "environments/environment";
import { VinculosLimiteDespesaViagemDTO } from "../models/vinculos-limite-despesa-viagem.model";

@Injectable({
    providedIn: "root"
})
export class RegrasLimiteDespesaViagemService extends CrudService<RegrasLimiteDespesaViagemDTO> implements Resolve<any>{
    
    routeParams: any;

    constructor(protected http: HttpClient) {
        super(http, `${environment.apiUrlRDV}/v1/regra-limite-despesa-viagem`);
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;
        if (this.routeParams.id === "new") {
            return new Promise((resolve, reject) => {
                this.onDataChanged.next(false);
                resolve(false);
            });
        } else {
            return this.getById(this.routeParams.id);
        }
    }
    
}